import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposDocumentoSunatConstant, TiposDocumentoSerieConstant } from 'constants/index'

import * as UsuarioService from 'services/usuario.service'

const SerieDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting, vTipoDocumento }) => {
  const [series, setSeries] = React.useState([])

  React.useEffect(() => {
    if (vTipoDocumento === TiposDocumentoSunatConstant.GUIA_REMISION_REMITENTE) {
      UsuarioService.self
        .obtenerSeriesxTipoSerie({ tipoSerie: TiposDocumentoSerieConstant.GUIAELECTRONICA_TRANSFERENCIAS })
        .then(({ data }) => {
          if (data && data.length > 0) {
            setSeries(data)
          }
        })
    }
  }, [vTipoDocumento])

  return (
    <Form.Group>
      <Form.Label text='SERIE DOCUMENTO' htmlFor='input-serieDocumento' md={4} alignRightAt='md' />
      <Col md={8}>
        {vTipoDocumento !== TiposDocumentoSunatConstant.GUIA_REMISION_REMITENTE ? (
          <Field name='serieDocumento'>
            {({ field }) => (
              <Form.InputText
                {...field}
                id='input-serieDocumento'
                disabled={fIsSubmitting}
                isInvalid={iTouched && iError}
              />
            )}
          </Field>
        ) : (
          <Field name='serieDocumento'>
            {({ field }) => (
              <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-serie'>
                <option value=''>Seleccionar</option>
                {series.map(x => (
                  <option key={x} value={x}>
                    {x}
                  </option>
                ))}
              </Form.Select>
            )}
          </Field>
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SerieDocumentoFormGroup)
